import { z } from 'zod'
import { Icon } from '@manychat/manyui'

import { isHeaderWithAttachment } from 'apps/whatsApp/MessageTemplates/helpers'
import { AttachmentAppearance } from 'common/builder/components/chart/FlowChart/types/AttachmentAppearance'
import { FlowChartAttachment } from 'common/builder/components/chart/FlowChart/types/FlowChartAttachment'
import { WaMessageTemplateHeaderType, messageTemplate } from 'shared/api/requests/whatsApp/schemas'

export function getAttachmentFromTemplate(
  template: z.infer<typeof messageTemplate> | null,
): FlowChartAttachment | null {
  if (
    !template ||
    !isHeaderWithAttachment(template.header) ||
    template.header.type === WaMessageTemplateHeaderType.IMAGE ||
    template.header.type === WaMessageTemplateHeaderType.TEXT
  ) {
    return null
  }

  let icon = Icon.Attach

  if (template.header.type === WaMessageTemplateHeaderType.VIDEO) {
    icon = Icon.Video
  }

  return {
    appearance: AttachmentAppearance.DEFAULT,
    title: template.header.name || '',
    icon,
  }
}
